// extracted by mini-css-extract-plugin
export default {"edit":"Header_edit__ulLMy","cancel":"Header_cancel__HCwz9"};